import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchJobDetail(_, jobId) {
  try {
    const res = await apiAxios.get(`/jobs/${jobId}`);
    return res.data.data;
  } catch (e) {
    console.log(e);
  }
}

function useJobDetailData(jobId) {
  const { user: userState } = useContext(LoginStateContext);

  return useQuery(["job-detail", jobId], fetchJobDetail, {
    enabled: userState.isLoggedIn && jobId,
  });
}

export default useJobDetailData;
